'use strict';

angular.module('app').directive('phoneMask', function ($timeout, $rootScope,localStorageService) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ctrl) {
            var phoneField = $(elem),
                callbackFinished = false;

            phoneField.intlTelInput({
                preferredCountries: [
                    'us', 'gb', 'de', 'ch'
                ],
                geoIpLookup: function (callback) {
                    callback(localStorageService.get('countryCode') || 'US');
                    // jQuery.get('http://ip-api.com/json', function () {
                    // }).always(function (resp) {
                    //     console.log(resp);
                    //     var countryCode = (resp && resp.countryCode) ? resp.countryCode : "";
                    //     callback(countryCode);
                    // });
                },
                initialCountry: 'auto'
            });

            // Set model value to valid, formatted version.
              ctrl.$validators.ngIntlTelInput = function (value) {
                // if phone number is deleted / empty do not run phone number validation
                if (value || phoneField[0].value.length > 0) {
                    return phoneField.intlTelInput('isValidNumber');
                } else {
                    return true;
                }
              };

            ctrl.$parsers.push(function (value) {
                return phoneField.intlTelInput('getNumber');
            });
              // Set input value to model value and trigger evaluation.
            ctrl.$formatters.push(function (value) {
                if (value) {
                  if(value.charAt(0) !== '+') {
                    value = '+' + value;
                  }
                  phoneField.intlTelInput('setNumber', value);
                }
                return value;
            });
        }
    };
});
